export function isRowBasedLoginFormat(width: number): boolean {
    return width < 710
}
